import saveData from "~/frontend/src/actions/panel/treeView/saveData";

export type SaveData = typeof saveData;

export default saveData;